var _g, _g2, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeechBubble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 792",
    enableBackground: "new 0 0 612 792",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gzynoC.tif",
    display: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#290F6B",
    d: "M189.8,583.7c-50.2,0-97.3-19.5-132.7-55s-55-82.5-55-132.7s19.5-97.3,55-132.7c35.4-35.5,82.5-55,132.7-55 s97.3,19.5,132.7,55c35.5,35.4,55,82.5,55,132.7c0,6.1-0.3,12.2-0.9,18.3l-0.1,1.5l222.7,93.6L353,488.8l-0.7,1.1 c-16.2,28-39.5,51.6-67.4,68C256.2,574.7,223.3,583.7,189.8,583.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M189.8,210.4c25.1,0,49.3,4.9,72.3,14.6c22.1,9.3,42,22.7,59,39.8c17,17,30.4,36.9,39.8,59 c9.7,22.9,14.6,47.2,14.6,72.3c0,6-0.3,12.1-0.9,18.1l-0.3,3l2.8,1.2l209.2,88l-231.8-19.5l-2.6-0.2l-1.3,2.3 c-16,27.7-39.1,50.9-66.7,67.2c-28.4,16.8-60.9,25.6-94.1,25.6c-25.1,0-49.3-4.9-72.3-14.6c-22.1-9.3-42-22.7-59-39.8 c-17-17-30.4-36.9-39.8-59C9,445.3,4.1,421.1,4.1,396c0-25.1,4.9-49.3,14.6-72.3c9.3-22.1,22.7-42,39.8-59c17-17,36.9-30.4,59-39.8 C140.4,215.3,164.7,210.4,189.8,210.4 M189.8,206.2C85,206.2,0,291.2,0,396s85,189.8,189.8,189.8c70.3,0,131.6-38.2,164.4-94.9 L612,512.6l-233.3-98.1l0,0c0.6-6.1,0.9-12.2,0.9-18.5C379.6,291.2,294.6,206.2,189.8,206.2L189.8,206.2z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 66.5802 300.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 20
  }, "We have now identified the")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 69.5802 322.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 20
  }, "skills you have employed ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 79.5802 344.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 20
  }, "throughout your career.")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 79.5802 385.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 20
  }, "Their levels are shown in")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 99.5802 407.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 20
  }, " your unique Skilldar.")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 89.5802 445.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 20
  }, "Press play for a short")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 84.5802 467.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 20
  }, "  explanation about your")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 89.5802 489.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 20
  }, "  skilldar from Laicie.")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speech-bubble.0fb9d8075a38355b9565cf2ad47ce647.svg";
export { ForwardRef as ReactComponent };